import {
	CampaignRoutingSettings,
	CampaignRoutingTargetState,
	isCampaignRoutingTargetUsable,
} from "@signalist/shared-types";

import { RoutingCampaign } from "./campaignRoutingTargets";

/** What happens to a lead no rule matched, as the API's fallback decides it. */
export type FallbackOutcome =
	| { kind: "DEFAULT"; campaignName: string }
	| { kind: "DEFAULT_UNUSABLE"; campaignName: string; state: CampaignRoutingTargetState }
	| { kind: "NO_DEFAULT" }
	| { kind: "NONE" };

/**
 * The fallback as the evaluator applies it: NO_CAMPAIGN preassigns nothing; DEFAULT_CAMPAIGN
 * preassigns the list's "(Default)" campaign only when it can take leads, else nothing.
 */
export const fallbackOutcomeOf = (
	settings: CampaignRoutingSettings,
	campaigns: readonly RoutingCampaign[]
): FallbackOutcome => {
	switch (settings.fallback) {
		case "NO_CAMPAIGN":
			return { kind: "NONE" };
		case "DEFAULT_CAMPAIGN": {
			const uuid = settings.defaultCampaignUuid;

			if (!uuid) {
				return { kind: "NO_DEFAULT" };
			}

			const campaignName = campaigns.find((campaign) => campaign.uuid === uuid)?.name ?? uuid;
			const state = settings.defaultCampaignState ?? "DELETED";

			return isCampaignRoutingTargetUsable(state)
				? { kind: "DEFAULT", campaignName }
				: { kind: "DEFAULT_UNUSABLE", campaignName, state };
		}

		default: {
			const unknownFallback: never = settings.fallback;

			throw new Error(`Unknown routing fallback ${String(unknownFallback)}`);
		}
	}
};
